module.exports.beginOverlay = () => {
	document.body.classList.add('noscroll')
}

module.exports.endOverlay = () => {
	document.body.classList.remove('noscroll')
}